import React from 'react';
import { SvgIcon, SvgIconProps } from '@material-ui/core';

export const ImportIcon = (props: SvgIconProps) => (
  <SvgIcon fill="none" viewBox="0 0 14 14" {...props}>
    <path
      d="M11.8483 11.8483C11.8483 12.2341 11.6951 12.604 11.4223 12.8768C11.1495 13.1496 10.7796 13.3028 10.3938 13.3028H3.60591C3.22014 13.3028 2.85017 13.1496 2.57739 12.8768C2.30461 12.604 2.15137 12.2341 2.15137 11.8483V2.15132C2.15137 1.76555 2.30461 1.39558 2.57739 1.1228C2.85017 0.850024 3.22014 0.696777 3.60591 0.696777H6.59834C6.85543 0.696816 7.10198 0.798947 7.28379 0.980717L11.5644 5.26132C11.7462 5.44313 11.8483 5.68969 11.8483 5.94678V6.68447M6.99991 0.939142V4.57551C6.99991 4.83269 7.10208 5.07933 7.28393 5.26119C7.46578 5.44304 7.71243 5.5452 7.96961 5.5452H11.606M7.90727 11.0841L6.27299 9.44985M6.27299 9.44985L7.90727 7.81557M6.27299 9.44985H11.5499"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </SvgIcon>
);
